import { render } from "./InspectionThanks.vue?vue&type=template&id=32aa25b6"
import script from "./InspectionThanks.vue?vue&type=script&lang=js"
export * from "./InspectionThanks.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/v3/InspectionThanks.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "32aa25b6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('32aa25b6', __exports__)) {
    api.reload('32aa25b6', __exports__)
  }
  
  module.hot.accept("./InspectionThanks.vue?vue&type=template&id=32aa25b6", () => {
    api.rerender('32aa25b6', render)
  })

}


export default __exports__